"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { EntityDisplay, SectionHeader, StatsGrid } from "fansunited-sports-ui";
import { useTeamPageData } from "../context/TeamPageDataContext";
import { Globe, Facebook, Instagram, Youtube } from "lucide-react";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { resolveSocials } from "@/utilities/socials/buildSocialUrl";
const XIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const TikTokIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const TeamClubInfo: React.FC = () => {
  const $ = _c(38);
  const {
    team
  } = useTeamPageData();
  const labels = useLabels().teamPage;
  const t0 = team.metadata?.socials;
  let t1;
  if ($[0] !== t0) {
    t1 = resolveSocials(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const socials = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      typography: {
        name: "text-sm uppercase font-semibold text-foreground"
      },
      container: "mb-2"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== labels.clubInfo.title) {
    t3 = <SectionHeader entity={{
      name: labels.clubInfo.title,
      styles: t2
    }} />;
    $[3] = labels.clubInfo.title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== labels.clubInfo.nickname || $[6] !== team.name || $[7] !== team.nickname) {
    t4 = team.nickname && team.nickname !== team.name ? [{
      id: "nickname",
      label: labels.clubInfo.nickname,
      value: team.nickname
    }] : [];
    $[5] = labels.clubInfo.nickname;
    $[6] = team.name;
    $[7] = team.nickname;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== labels.clubInfo.country || $[10] !== team.country) {
    t5 = team.country?.name ? [{
      id: "country",
      label: labels.clubInfo.country,
      value: team.country.name
    }] : [];
    $[9] = labels.clubInfo.country;
    $[10] = team.country;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== labels.clubInfo.founded || $[13] !== team.founded) {
    t6 = team.founded ? [{
      id: "founded",
      label: labels.clubInfo.founded,
      value: team.founded.toString()
    }] : [];
    $[12] = labels.clubInfo.founded;
    $[13] = team.founded;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== labels.clubInfo.capacity || $[16] !== labels.clubInfo.stadium || $[17] !== team.venue) {
    t7 = team.venue ? [{
      id: "stadium",
      label: labels.clubInfo.stadium,
      value: <EntityDisplay imagePosition="right" name={team.venue.name || ""} subtitle={team.venue.profile?.capacity ? `${team.venue.profile.capacity.toLocaleString()} ${labels.clubInfo.capacity}` : ""} imageUrl="" styles={{
        textAlign: "right",
        imageSize: "xl"
      }} />
    }] : [];
    $[15] = labels.clubInfo.capacity;
    $[16] = labels.clubInfo.stadium;
    $[17] = team.venue;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== labels.clubInfo.manager || $[20] !== team.coach) {
    t8 = team.coach ? [{
      id: "manager",
      label: labels.clubInfo.manager,
      value: <EntityDisplay imagePosition="right" name={team.coach.name || ""} subtitle={team.coach.country?.name || ""} imageUrl="" styles={{
        textAlign: "right",
        imageSize: "xl"
      }} />
    }] : [];
    $[19] = labels.clubInfo.manager;
    $[20] = team.coach;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== labels.clubInfo.socials || $[23] !== socials) {
    t9 = socials ? [{
      id: "socials",
      label: labels.clubInfo.socials,
      value: <div><div className="flex gap-3">{socials.website && <a href={socials.website} target="_blank" rel="noopener noreferrer nofollow" className="p-2 rounded-full bg-muted hover:bg-muted/80 transition-colors" aria-label="Website"><Globe className="w-5 h-5" /></a>}{socials.x && <a href={socials.x} target="_blank" rel="noopener noreferrer nofollow" className="p-2 rounded-full bg-muted hover:bg-muted/80 transition-colors" aria-label="X"><XIcon className="w-5 h-5" /></a>}{socials.facebook && <a href={socials.facebook} target="_blank" rel="noopener noreferrer nofollow" className="p-2 rounded-full bg-muted hover:bg-muted/80 transition-colors" aria-label="Facebook"><Facebook className="w-5 h-5" /></a>}{socials.instagram && <a href={socials.instagram} target="_blank" rel="noopener noreferrer nofollow" className="p-2 rounded-full bg-muted hover:bg-muted/80 transition-colors" aria-label="Instagram"><Instagram className="w-5 h-5" /></a>}{socials.youtube && <a href={socials.youtube} target="_blank" rel="noopener noreferrer nofollow" className="p-2 rounded-full bg-muted hover:bg-muted/80 transition-colors" aria-label="YouTube"><Youtube className="w-5 h-5" /></a>}{socials.tiktok && <a href={socials.tiktok} target="_blank" rel="noopener noreferrer nofollow" className="p-2 rounded-full bg-muted hover:bg-muted/80 transition-colors" aria-label="TikTok"><TikTokIcon className="w-5 h-5" /></a>}</div></div>
    }] : [];
    $[22] = labels.clubInfo.socials;
    $[23] = socials;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t10 = [...t4, ...t5, ...t6, ...t7, ...t8, ...t9];
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      grid: {
        colsDesktop: 1,
        colsMobile: 1
      },
      item: {
        container: "bg-card shadow-sm py-3.5"
      }
    };
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10) {
    t12 = <StatsGrid items={t10} itemVariant="horizontal" styles={t11} />;
    $[33] = t10;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t3) {
    t13 = <div>{t3}{t12}</div>;
    $[35] = t12;
    $[36] = t3;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};